/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/**
 * Route components for the config-driven Real Estate pages (reEntityConfig).
 * routes.js mounts <ReEntityList entityKey="re-units" /> and
 * <ReEntityDetail entityKey="re-units" /> (the detail looks up the config of
 * its list key).
 */

import { useMemo } from "react";
import PropTypes from "prop-types";
import { EntityDetail, EntityList } from "components/EntityFramework";
import { getReEntityConfig } from "./reEntityConfig";
import { localiseConfig } from "./reEntityVariant";
import useReVariant from "./useReVariant";
import pluralTitle from "./pluralTitle";

/** The page's config in the tenant's country (UAE / Australia). */
const useLocalConfig = (entityKey) => {
  const pack = useReVariant();
  return useMemo(() => localiseConfig(getReEntityConfig(entityKey), pack), [entityKey, pack]);
};

export const ReEntityList = ({ entityKey }) => {
  const config = useLocalConfig(entityKey);
  const listConfig = useMemo(
    () => (config ? { ...config, pageTitle: config.pageTitle || pluralTitle(config.title) } : config),
    [config],
  );
  return <EntityList config={listConfig} permissionObject={config?.permissionObject} />;
};

ReEntityList.propTypes = { entityKey: PropTypes.string.isRequired };

export const ReEntityDetail = ({ entityKey }) => {
  const config = useLocalConfig(entityKey);
  return <EntityDetail config={config} permissionObject={config?.permissionObject} />;
};

ReEntityDetail.propTypes = { entityKey: PropTypes.string.isRequired };
